import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import DisplayTextField from "../../../components/Questions/DisplayTextField";
import { TextField, Button, MenuItem, Menu, Tooltip } from "@mui/material";
import { Student_Update_To_MongoDB_By_ID } from "../../../api/Student_Update_To_MongoDB_By_ID";
import { StudentuseAuth } from "../../../security/StudentUseAuth";

function SEFProgressBox({ Attendee, setAttendee, Arr_SEFPages }) {
  const { logoutStudent } = StudentuseAuth();

  let MedicalCheck = false;
  let DisplayQuestions = [];
  if (
    Attendee.SEFInfo &&
    Attendee.SEFInfo?.completing_the_form_Full_name_of_the_person
  ) {
    MedicalCheck = true;
    DisplayQuestions = Arr_SEFPages;
  } else {
    DisplayQuestions = Arr_SEFPages.slice(0, 5);
  }

  const Arr_WhoCompletingQuestions = [
    // Arr_WhoCompletingQuestions
    {
      Page: "SEFInfo",
      TextField: "TextFieldForObjectState",
      label: "Full name of the person completing the form",
      name: "completing_the_form_Full_name_of_the_person",
      onlyAppearIfValueIs: false,
      onlyAppearIfValueIsNot: false,
      withRegardsTo: false,
    },
    {
      Page: "SEFInfo",
      TextField: "TextFieldForObjectState",
      label: "Email address of the person completing the form",
      name: "completing_the_form_Email_of_the_person",
      onlyAppearIfValueIs: false,
      onlyAppearIfValueIsNot: false,
      withRegardsTo: false,
    },
    {
      Page: "SEFInfo",
      TextField: "SelectFieldForObjectState",
      label: "Your relationship to the student",
      name: "completing_the_form_Your_relationship_to_the_student",
      selectValues: ["Mother", "Father", "Legal Guardian"],
      onlyAppearIfValueIs: false,
      onlyAppearIfValueIsNot: false,
      withRegardsTo: false,
    },
    {
      Page: "SEFInfo",
      TextField: "TextFieldForObjectState",
      label:
        "Please specify your relationship to the student (e.g. foster parent)",
      name: "completing_the_form_relationship_specified",
      onlyAppearIfValueIs: ["Legal Guardian"],
      onlyAppearIfValueIsNot: false,
      withRegardsTo: "completing_the_form_Your_relationship_to_the_student",
    },
  ];

  const [formInfo, setformInfo] = useState({});
  const handleChange = (e) => {
    const { name, value } = e.target;
    setformInfo((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const [status, setStatus] = useState(false);
  const handleSubmit = () => {
    Student_Update_To_MongoDB_By_ID(
      {
        "SEFInfo.completing_the_form_Full_name_of_the_person":
          formInfo.completing_the_form_Full_name_of_the_person || "",
        "SEFInfo.completing_the_form_Email_of_the_person":
          formInfo.completing_the_form_Email_of_the_person || "",
        "SEFInfo.completing_the_form_Your_relationship_to_the_student":
          formInfo.completing_the_form_Your_relationship_to_the_student || "",
        "SEFInfo.completing_the_form_relationship_specified":
          formInfo.completing_the_form_relationship_specified || "",
        "SEFInfo.ShowMedicalAccessQuestions": "",
      },
      "Registers_2025",
      "All",
      setStatus,
      localStorage.getItem("Student_id"),
      "This page has been submitted, you may now navigate to another page using the buttons at the bottom or close this tab",
      logoutStudent
    );
    setAttendee((prevData) => ({
      ...prevData,
      ["SEFInfo"]: formInfo,
    }));
  };

  console.log(Attendee);

  let isFormComplete =
    formInfo.completing_the_form_Full_name_of_the_person &&
    formInfo.completing_the_form_Email_of_the_person &&
    ((formInfo.completing_the_form_Your_relationship_to_the_student &&
      formInfo.completing_the_form_Your_relationship_to_the_student !==
        "Legal Guardian") ||
      (formInfo.completing_the_form_Your_relationship_to_the_student &&
        formInfo.completing_the_form_relationship_specified));

  function medicalAccessQuestionsComponent() {
    return (
      <>
        <div className="view-basic-info-container">
          <p>
            The next section is about health and{" "}
            <b>
              <u>must</u>{" "}
            </b>
            be completed by the student’s parent(s) or legal guardian(s) with
            parental responsibilities to ensure we have accurate, shared
            knowledge of the student. Parent(s) or legal guardian(s) with
            parental responsibilities, may only use an Education Consultant or
            interpreter for translation purposes for this section.
            <br></br>
            <br></br>
            Please confirm who will be completing the following health sections:
          </p>
          {/* Who is completing the medical form */}
          <DisplayTextField
            formInfo={formInfo}
            handleChange={handleChange}
            Object={Arr_WhoCompletingQuestions[0]}
          />
          <br></br>
          <br></br>
          <br></br>
          <DisplayTextField
            formInfo={formInfo}
            handleChange={handleChange}
            Object={Arr_WhoCompletingQuestions[1]}
          />
          <br></br>
          <br></br>
          <br></br>
          <DisplayTextField
            formInfo={formInfo}
            handleChange={handleChange}
            Object={Arr_WhoCompletingQuestions[2]}
          />
          <br></br>
          <br></br>
          <br></br>
          <DisplayTextField
            formInfo={formInfo}
            handleChange={handleChange}
            Object={Arr_WhoCompletingQuestions[3]}
          />
          <br></br>
          <br></br>
          <br></br>
          <div className="view-basic-info-buttons">
            <Button
              variant="contained"
              color="secondary"
              onClick={handleSubmit}
              disabled={!isFormComplete || status}
            >
              Submit
            </Button>
          </div>{" "}
        </div>
      </>
    );
  }

  return (
    <>
      {Attendee.SEFInfo?.ShowMedicalAccessQuestions === "Yes" ? (
        <>{medicalAccessQuestionsComponent()}</>
      ) : (
        <></>
      )}
      <div className="progress-box">
        <div className="progress-container">
          {DisplayQuestions.map((item, index) => (
            <div key={index} className="progress-item">
              <div className="progress-item-content">
                <span className="progress-text">
                  <strong style={{ fontSize: "max(0.8vw, 12px)" }}>
                    {item.label}
                  </strong>
                </span>
              </div>
              <div className="progress-bar">
                <div
                  className={`progress-bar-fill ${
                    Attendee &&
                    Attendee.SEFProgress &&
                    Attendee.SEFProgress[item.Prop]
                      ? //
                        Attendee.SEFProgress[item.Prop] === "Complete"
                        ? "Complete"
                        : Attendee.SEFProgress[item.Prop] === "In_Progress"
                        ? "In_Progress"
                        : Attendee.SEFProgress[item.Prop] === "Awaiting_Review"
                        ? "Awaiting_Review"
                        : "Incomplete"
                      : //
                        "Incomplete"
                  }`}
                >
                  <span
                    className={`progress-bar-text ${
                      Attendee &&
                      Attendee.SEFProgress &&
                      Attendee.SEFProgress[item.Prop]
                        ? //
                          Attendee.SEFProgress[item.Prop] === "Complete"
                          ? "Complete"
                          : Attendee.SEFProgress[item.Prop] === "In_Progress"
                          ? "In_Progress"
                          : Attendee.SEFProgress[item.Prop] ===
                            "Awaiting_Review"
                          ? "Awaiting_Review"
                          : "Incomplete"
                        : //
                          "Incomplete"
                    }`}
                    style={{ fontSize: "max(0.8vw, 12px)" }}
                  >
                    {Attendee && Attendee._id && Attendee._id.length > 0
                      ? //
                        Attendee.SEFProgress && Attendee.SEFProgress[item.Prop]
                        ? //
                          Attendee.SEFProgress[item.Prop] === "Complete"
                          ? "Complete"
                          : Attendee.SEFProgress[item.Prop] === "In_Progress"
                          ? "In Progress"
                          : Attendee.SEFProgress[item.Prop] === "Incomplete"
                          ? "Incomplete"
                          : Attendee.SEFProgress[item.Prop] ===
                            "Awaiting_Review"
                          ? "Awaiting Review"
                          : "Incomplete"
                        : //
                          "Incomplete"
                      : //
                        "Loading..."}
                  </span>
                </div>
              </div>
              <Link
                to={`/Student/${item.link}/${
                  Attendee._id && Attendee._id.length > 0 ? Attendee._id : ""
                }`}
                style={{
                  textDecoration: "none",
                  color: "inherit",
                  width: "20%",
                  marginRight: "10px",
                }}
                target="_blank"
              >
                <button
                  className={`go-to-button ${
                    Attendee && Attendee._id && Attendee._id.length > 0
                      ? //
                        Attendee.SEFProgress && Attendee.SEFProgress[item.Prop]
                        ? //
                          Attendee.SEFProgress[item.Prop] === "Complete"
                          ? "Complete"
                          : Attendee.SEFProgress[item.Prop] === "In Progress"
                          ? "In Progress"
                          : Attendee.SEFProgress[item.Prop] === "Incomplete"
                          ? "Incomplete"
                          : Attendee.SEFProgress[item.Prop] ===
                            "Awaiting Review"
                          ? "Awaiting Review"
                          : "Incomplete"
                        : //
                          "Incomplete"
                      : //
                        "Loading..."
                  }`}
                >
                  View Page
                </button>
              </Link>
            </div>
          ))}
        </div>
      </div>

      {!MedicalCheck ? <>{medicalAccessQuestionsComponent()}</> : <></>}
    </>
  );
}

export default SEFProgressBox;
